module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(" " + _vm._s(_vm.regularStreamStart.date) + " to " + _vm._s(_vm.regularStreamEnd.date) + " " + _vm._s(_vm.regularStreamStart.time))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-937fcd12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/StreamTimes.vue
// module id = 1050
// module chunks = 2 3